import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Tag } from 'antd';
import {
  contractsStatuses,
  contractsTypes
} from '../../utils/constants/tagColors';
import { routes, subRoutes } from '../../utils/constants/routes';
import useAuthContext from '../../contexts/AuthContext';
import useContractsContext from './ContractsContext';

const useColumns = () => {
  const { t } = useTranslation();
  const { user } = useAuthContext();
  const { enums } = useContractsContext();

  return [
    ...(user?.role !== 'guests:GUEST'
      ? [
          {
            title: t('contracts.column.client'),
            dataIndex: 'customer',
            key: 'customer',
            render: (customer, { key }) =>
              customer && (
                <Link
                  to={`${routes.CONTRACTS}${subRoutes.CONTRACTS.PORTFOLIO_CLIENTS}/show/${key}`}
                >
                  {`${customer.first_name} ${customer.last_name}`}
                </Link>
              ),
            sorter: true
          }
        ]
      : []),
    {
      title: t('contracts.column.number'),
      dataIndex: 'number',
      key: 'number',
      render: (number) => number,
      sorter: true
    },
    {
      title: t('contracts.column.contractType'),
      dataIndex: 'type',
      key: 'type',
      render: (contractType) => (
        <Tag color={contractsTypes[contractType]}>
          {t(`contracts.tags.${contractType}`)}
        </Tag>
      ),
      filters: enums?.type?.map((p) => ({
        text: t(`contracts.tags.${p}`),
        value: p
      })),
      sorter: true,
      width: 100
    },
    {
      title: t('contracts.form.contract_status'),
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={contractsStatuses[status]}>
          {t(`contracts.tags.${status}`)}
        </Tag>
      ),
      filters: enums?.statuses
        .filter((f) => f !== 'QUOTE')
        .map((p) => ({
          text: t(`contracts.tags.${p}`),
          value: p
        })),
      sorter: true
    },
    {
      title: t('contracts.column.start_date'),
      dataIndex: 'effective_date',
      key: 'effective_date',
      render: (date) => date && moment(date).utc().format('DD/MM/YYYY'),
      sorter: true
    },
    ...(user?.role !== 'guests:GUEST'
      ? [
          {
            title: t('contracts.column.exemption_link'),
            dataIndex: 'exemption_link',
            key: 'exemption_link',
            render: (exemption_link) =>
              exemption_link
                ? t('quotes.form.switch.true')
                : t('quotes.form.switch.false'),
            sorter: true
          }
        ]
      : []),
    {
      title: t('contracts.column.insurer'),
      dataIndex: 'insurer',
      key: 'insurer',
      width: 140,
      render: (insurer) => insurer?.name,
      sorter: true
    }
  ];
};

export default useColumns;
